import React from 'react'

const WContainer = ({ fluid, inner, children }) => {
  return (
    <div className={'w-container' + (fluid ? '-fluid' : inner ? '-inner' : '')}>{children}</div>
  )
}

export default WContainer
